import axios from "axios";
import ServiceHelper from "./serviceHelper";
import envConfig from "../config";
class FileService {
  static fileNameWithoutExtension = (fileName) => {
    return fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
  };

  static getFile = async (mediaId, isAttachment = false) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/File/getFile/${mediaId}/${isAttachment}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return null;
        throw error;
      });
  };

  static getMetaData = async (mediaId) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .get(`${envConfig.apiBaseUrl}/api/File/getMetaData/${mediaId}`, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return null;
        throw error;
      });
  };

  static updateMetaData = async (mediaMetaData) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/File/updateMetaData`, mediaMetaData, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return null;
        throw error;
      });
  };

  static deleteFile = async (mediaId) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .delete(`${envConfig.apiBaseUrl}/api/File/delete/${mediaId}`, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "delete");
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return null;
        throw error;
      });
  };

  static getFolderBrowser = async (clientExternalId, horseExternalId) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/File/getFolderTree`, { clientExternalId, horseExternalId }, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return null;
        throw error;
      });
  };

  static getFileFolderPreview = async (filterObj) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/File/getFileFolderPreview`, filterObj, config)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return [];
        throw error;
      });
  };

  static UploadFromLibrary = async (fileId) => {
    const config = ServiceHelper.ApiCallPrevalidateAndGetConfig();

    return axios
      .post(`${envConfig.apiBaseUrl}/api/File/duplicate/${fileId}`, null, config)
      .then((response) => {
        ServiceHelper.ApiCallPostValidation(response, "create");
        if (response.status !== 200) {
          return { success: false };
        }
        return { success: true, id: response.data.data };
      })
      .catch((error) => {
        const ok = ServiceHelper.ApiCallPostCatchValidation(error);
        if (ok) return null;
        throw error;
      });
  };

  static uploadFile = async (selectedFile, thumbnail, fileDate, fileName, tags) => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("thumbnail", thumbnail);
    formData.append("fileDate", fileDate.toISOString());
    formData.append("fileName", fileName);
    formData.append("tags", tags);

    const expireOn = localStorage.getItem("expireOn");
    const token = localStorage.getItem("token");
    if (!token || !expireOn) {
      return;
    }

    try {
      const response = await fetch(`${envConfig.apiBaseUrl}/api/File/upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        ServiceHelper.ApiCallPostValidation({ data: { success: true } }, "upload");
        return { success: false };
      }
      ServiceHelper.ApiCallPostValidation({ data: { success: true } }, "upload");
      const data = await response.json();
      return { success: true, id: data.data };
    } catch (error) {
      const ok = ServiceHelper.ApiCallPostCatchValidation(error);
      if (ok) return;
      throw error;
    }
  };
}
export default FileService;
